import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { StrategyHelpers } from '../../service/StrategyHelpers/StrategyHelpers';
import { CampaignStrategy } from '../../typings/domain';
import { ClientFeatures } from '../../typings/state';
import { TextCell } from '../TextCell/TextCell';

export interface GridCampignStrategyCellProps {
    strategy: CampaignStrategy;
    features: ClientFeatures;
}

export class GridCampignStrategyCell extends React.Component<GridCampignStrategyCellProps> {
    render() {
        const { strategy, features } = this.props;

        return (
            <div className={Bem.cls('grid-campaign-strategy-cell')}>
                <TextCell>{StrategyHelpers.getTitle(features, strategy.type, strategy.platform)}</TextCell>
            </div>
        );
    }
}
